module.exports = __webpack_public_path__ + "static/img/runbo5.9c99fc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/runbo5.png
// module id = 3T9i
// module chunks = 4